import { render, staticRenderFns } from "./LayoutEditDetailsTab.vue?vue&type=template&id=b1773d3a"
import script from "./LayoutEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports